import axios from "axios";
import useOnboarding from "hooks/companySettings/useOnboarding";
import subdomain from "lib/subdomain";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TokenService from "services/token.service";
import { objectToSnake } from "ts-case-convert";
import { api } from "services/api.service";
export const HOSTNAME = process.env.REACT_APP_API_BASE_URL || "";
export { api };
export const api1 = axios.create({
  baseURL: `${HOSTNAME}`,
  withCredentials: true,
});

api1.interceptors.request.use(
  (config: any) => {
    if (TokenService.get("accessToken")) config.headers.Authorization = `Bearer ${TokenService.get("accessToken")}`;

    if (config.data) {
      config.data = objectToSnake(config.data);
    }

    const organizationSubdomain = subdomain();
    if (organizationSubdomain) {
      config.headers["organization-subdomain"] = organizationSubdomain;
    }

    return config;
  },
  (error: Error) => {
    return Promise.reject(error);
  },
);

interface SamlSetting {
  provider?: string;
}

export default function useSaml() {
  const { fetchOnboarding } = useOnboarding();
  const navigate = useNavigate();
  const [samlSetting, setSamlSetting] = useState<SamlSetting>();
  const [isLoading, setIsLoading] = useState(false);

  const samlLogin = () => {
    api1.post("/saml/v1/init").then((response: any) => {
      window.location.href = response.data.redirect_url;
    });
  };

  const createSamlSettings = (args: any) => {
    api
      .post("/saml_settings", { saml_setting: args })
      .then(() => {
        navigate("/company-settings/authentication");
      })
      .finally(() => {
        fetchOnboarding && fetchOnboarding();
      });
  };

  const getSamlSetting = () => {
    api.get("/saml_settings").then((response: any) => {
      setSamlSetting(response.data.samlSetting);
      setIsLoading(false);
    });
  };

  const deactivateSaml = () => {
    api
      .delete("/saml_settings")
      .then(() => {
        getSamlSetting();
      })
      .finally(() => {
        fetchOnboarding && fetchOnboarding();
      });
  };

  useEffect(() => {
    if (!samlSetting && TokenService.get("accessToken") && !window.location.href.includes("login")) {
      setIsLoading(true);
      getSamlSetting();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    samlLogin,
    createSamlSettings,
    samlSetting,
    isLoading,
    deactivateSaml,
  };
}
